<template>
    <iframe
        v-if="showIframe"
        :src="$universe.data().home_url"
        class="fill-height fill-width home"
    />
    <component :is="universeComponent" v-else class="fill-height fill-width home" />
</template>

<script>
const PhebeHome = () => import("./phebe/PhebeHome");
const KyoseilHome = () => import("./kyoseil/KyoseilHome");
const MutualizeHome = () => import("./mutualize/MutualizeHome");
const NeotreesHome = () => import("./neotrees/NeotreesHome");
const ArthaudHome = () => import("./arthaud/ArthaudHome");
const DataFactoryHome = () => import("./datafactory/DataFactoryHome");
const MagnitudeHome = () => import("./magnitude/MagnitudeHome");
const StarkIncHome = () => import("./starkInc/StarkIncHome");
const NoqktaHome = () => import("./noqkta/NoqktaHome");
const KastelHome = () => import("./kastel-club/KastelHome");
const MySeedAdvisorHome = () => import("./mySeedAdvisor/MySeedAdvisorHome");
const AetherfsHome = () => import("./aetherfs/AetherfsHome");
const EfesoHome = () => import("./efeso/EfesoHome");
const LandquireHome = () => import("./landquire/LandquireHome");
const PvhVenturesHome = () => import("./pvhVentures/PvhVenturesHome");
const MaresquierPartnersHome = () => import("./maresquierPartners/MaresquierPartnersHome");
const FlorestanHome = () => import("./florestan-im/FlorestanHome");
const FlagHome = () => import("./flag/FlagHome");
const EquisafeWealthHome = () => import("./equisafeWealth/EquisafeWealthHome");

export default {
    name: "Home",
    component: [
        PhebeHome,
        KyoseilHome,
        MutualizeHome,
        NeotreesHome,
        ArthaudHome,
        DataFactoryHome,
        MagnitudeHome,
        StarkIncHome,
        KastelHome,
        NoqktaHome,
        MySeedAdvisorHome,
        AetherfsHome,
        EfesoHome,
        LandquireHome,
        PvhVenturesHome,
        MaresquierPartnersHome,
        FlorestanHome,
        FlagHome,
        EquisafeWealthHome,
    ],
    data() {
        return {
            showIframe: false,
            universeComponent: null
        };
    },
    beforeMount() {
        switch (this.$universe.slug()) {
            case "phebe":
                this.universeComponent = PhebeHome;
                break;
            case "kyoseil":
                this.universeComponent = KyoseilHome;
                break;
            case "mutualize":
                this.universeComponent = MutualizeHome;
                break;
            case "neotrees":
                this.universeComponent = NeotreesHome;
                break;
            case "arthaud":
                this.universeComponent = ArthaudHome;
                break;
            case "datafactory":
                this.universeComponent = DataFactoryHome;
                break;
            case "magnitude":
                this.universeComponent = MagnitudeHome;
                break;
            case "stark-inc":
                this.universeComponent = StarkIncHome;
                break;
            case "kastel-club":
                this.universeComponent = KastelHome;
                break;
            case "club-noqkta":
                this.universeComponent = NoqktaHome;
                break;
            case "my-seed-advisor":
                this.universeComponent = MySeedAdvisorHome;
                break;
            case "aetherfs":
                this.universeComponent = AetherfsHome;
                break;
            case "efeso":
                this.universeComponent = EfesoHome;
                break;
            case "pvh-ventures":
                this.universeComponent = PvhVenturesHome;
                break;
            case "maresquier-partners":
                this.universeComponent = MaresquierPartnersHome;
                break;
            case "florestan-im":
                this.universeComponent = FlorestanHome;
                break;
            case "flag":
                this.universeComponent = FlagHome;
                break;
            case "landquire":
                this.universeComponent = LandquireHome;
                break;
            case "equisafe-wealth":
                this.universeComponent = EquisafeWealthHome;
                break;
            default:
                this.universeComponent = null;
                break;
        }
        const homeUrl = this.$universe.data().home_url;
        if (homeUrl === "https://test.com") {
            this.showIframe = false;
        } else {
            this.showIframe = !!homeUrl;
        }
    }
};
</script>

<style lang="scss" scoped>
.home {
    padding: 0px !important;
    border-width: 0px !important;
    background-color: #f3f2ff;
}
</style>
